import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { TarifartKostenApi } from './SchadenmeldungTarifartKostenApi';
import { SchadenmeldungKostenPositionApi } from './SchadenmeldungSchadenmeldungKostenPositionApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungKostenRequest
 * Kosten für die einzelnen Positionen
 * Endpoints: /api/schadenmeldungen/schadenkosten
 */
export class SchadenmeldungKostenRequestApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenmeldungKostenRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected tarif: TarifartKostenApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.TarifartKosten
	 */
	get Tarif(): TarifartKostenApi {
		return this.tarif;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.TarifartKosten
	 */
	set Tarif(value: TarifartKostenApi) {
		this.tarif = value;
	}

	protected schadenkosten: SchadenmeldungKostenPositionApi[];
	/**
	 * Description: Liste der einzelnen Kostenpositionen
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungKostenPosition>
	 */
	get Schadenkosten(): SchadenmeldungKostenPositionApi[] {
		return this.schadenkosten;
	}

	/**
	 * Description: Liste der einzelnen Kostenpositionen
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungKostenPosition>
	 */
	set Schadenkosten(value: SchadenmeldungKostenPositionApi[]) {
		this.schadenkosten = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenmeldungKostenRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenmeldungKostenRequestApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'schadenkosten':
					const resultschadenkosten = new Array<SchadenmeldungKostenPositionApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultschadenkosten.push(SchadenmeldungKostenPositionApi.createFromObject(v));
						});
					}
					return resultschadenkosten;
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Tarif = this.tarif;
		const schadenkostenArrayReqObject: object[] = [];
		this.schadenkosten.forEach((element) => {
			schadenkostenArrayReqObject.push(element.toRequestObject());
		});
		result.Schadenkosten = schadenkostenArrayReqObject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}